import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import * as React from 'react';
import { useErrorMessages } from '../../../../models/hooks/appStateHooks';
import { getFormattedPhoneNumber } from '../../../../models/UiUtils';
import { useAddProviderPhoneNumberMutation } from '../../../../queries';
import { Checkbox } from '../../../../web/components/Checkbox';
import { LoadingSpinner } from '../../../../web/components/LoadingSpinner';
import { TextInput } from '../../../../web/components/TextInput';
import { baseStyleSheet } from '../../../../web/styles/styles';
import { styleSheet } from './styles';

interface IProps {
	impersonationContext: Api.IImpersonationContext;
	onSuccess: () => void;
	provider: Api.ETextingFeatureProvider;
}

export function ProviderPhoneNumberForm({ onSuccess, impersonationContext, provider }: IProps) {
	const errorMessages = useErrorMessages();
	const [phonenumber, setPhonenumber] = React.useState('');
	const [scope, setScope] = React.useState<'User' | 'Account'>('User');
	const mutation = useAddProviderPhoneNumberMutation({
		impersonationContext,
		onError: error => {
			errorMessages.pushApiError(error);
		},
		onSuccess,
	});
	const onPhonenumberChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
		setPhonenumber(getFormattedPhoneNumber(ev.target.value));
	};
	const onScopeChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
		setScope(ev.target.checked ? 'Account' : 'User');
	};
	const onSaveProviderPhoneNumber = () => {
		mutation.mutate({ phonenumber, scope });
	};
	return (
		<div className={css(styleSheet.providerForm)}>
			<p className={css(styleSheet.providerFormHeader)}>Import {provider} Number</p>
			<TextInput inputId='provider-phonenumber' type='text' value={phonenumber} onChange={onPhonenumberChange} />
			<Checkbox checked={scope === 'Account'} onChange={onScopeChange} id='provider-phonenumber-scope'>
				<span>Shared</span>
			</Checkbox>
			<button
				disabled={mutation.isPending}
				className={css(baseStyleSheet.ctaButton)}
				onClick={onSaveProviderPhoneNumber}
			>
				{mutation.isPending ? <LoadingSpinner type='tiny' className={css(styleSheet.providerFormBtnSpinner)} /> : null}{' '}
				Save
			</button>
		</div>
	);
}
